var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenchIconsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205.423,
    height: 148.98,
    viewBox: "0 0 205.423 148.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8299",
    "data-name": "Group 8299",
    transform: "translate(8.189 -953.478)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1238",
    "data-name": "Rectangle 1238",
    width: 94.93,
    height: 83.702,
    rx: 10.144,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 111.912, 953.478)",
    fill: "#DC083A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1237",
    "data-name": "Rectangle 1237",
    width: 109.628,
    height: 109.628,
    rx: 10.144,
    transform: "translate(-8.189 992.831)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8957",
    "data-name": "Group 8957",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 23.704, 1010.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8968",
    "data-name": "Group 8968",
    transform: "translate(102.814 -50.26) rotate(25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M5.2,48.526a.794.794,0,0,0,.919.644l38.283-6.75a.793.793,0,0,0,.643-.919L39.858,12.051a.793.793,0,0,0-.919-.644l-10.6,1.869-6.9-8.271a3.766,3.766,0,0,0,.2-1.218,3.829,3.829,0,0,0-.058-.661A3.783,3.783,0,0,0,17.861,0,3.824,3.824,0,0,0,17.2.058,3.784,3.784,0,0,0,14.073,3.78a3.824,3.824,0,0,0,.058.661,3.776,3.776,0,0,0,.606,1.48L10.98,16.337.655,18.158a.793.793,0,0,0-.643.919Zm12.272-46.9h0a2.222,2.222,0,0,1,.385-.034,2.2,2.2,0,0,1,.378,4.361h0a2.2,2.2,0,1,1-.764-4.327M16.005,7.082a3.765,3.765,0,0,0,2.509.428h0A3.776,3.776,0,0,0,20.56,6.432l5.975,7.163L12.782,16.019ZM11.59,17.841a.782.782,0,0,0,.216-.038l16.257-2.867a.79.79,0,0,0,.216-.038l10.154-1.791L43.35,40.993,6.629,47.469,1.712,19.582Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M34.358,56.833a8.312,8.312,0,0,0,1.338-.109h0a8.262,8.262,0,1,0-1.339.109m1.084-1.675a6.689,6.689,0,0,1-7.758-6.6,6.643,6.643,0,0,1,.838-3.22L39.283,53.08a6.64,6.64,0,0,1-3.842,2.078M33.293,41.967h0a6.689,6.689,0,0,1,7.758,6.6,6.648,6.648,0,0,1-.839,3.222L29.449,44.047a6.638,6.638,0,0,1,3.843-2.08",
    transform: "translate(-11.836 -18.275)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M38.8,40.492Z",
    transform: "translate(-17.597 -18.365)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8966",
    "data-name": "Group 8966",
    transform: "translate(14.191 1011.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8967",
    "data-name": "Group 8967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7373",
    "data-name": "Path 7373",
    d: "M61.66,147.677H53.934a11.892,11.892,0,0,0-11.856-11.1h-2.77a14.217,14.217,0,1,0-13.752,0h-2.77a11.892,11.892,0,0,0-11.85,11.1H3.2a3.209,3.209,0,0,0-3.2,3.2v8.083a.889.889,0,1,0,1.777.073q0-.037,0-.073v-8.083A1.429,1.429,0,0,1,3.2,149.454H61.66a1.429,1.429,0,0,1,1.427,1.427v8.083a.889.889,0,1,0,1.777.073q0-.037,0-.073v-8.083a3.209,3.209,0,0,0-3.2-3.2M19.992,124.138a12.44,12.44,0,1,1,12.442,12.439h0a12.455,12.455,0,0,1-12.44-12.439m2.794,14.219H42.079a10.112,10.112,0,0,1,10.067,9.324H12.714a10.112,10.112,0,0,1,10.073-9.324",
    transform: "translate(0 -93.347)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7374",
    "data-name": "Path 7374",
    d: "M307.738,83.314h2.3l-3.023,4.261a.889.889,0,0,0,.725,1.4h4.024a.889.889,0,0,0,.073-1.777q-.037,0-.073,0h-2.311l3.029-4.267a.889.889,0,0,0-.725-1.4h-4.024a.889.889,0,0,0-.073,1.777q.037,0,.073,0Z",
    transform: "translate(-260.569 -69.242)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7375",
    "data-name": "Path 7375",
    d: "M351.968,1.778h4.815l-5.545,7.8a.889.889,0,0,0,.725,1.4H358.5a.889.889,0,0,0,.073-1.777q-.037,0-.073,0h-4.815l5.54-7.8A.889.889,0,0,0,358.5,0h-6.531a.889.889,0,0,0-.073,1.777q.037,0,.073,0",
    transform: "translate(-298.133 0)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchIconsGroup);
export default __webpack_public_path__ + "static/media/bench-icons-group.0b4c4be1609f52154d854325aedae4fc.svg";
export { ForwardRef as ReactComponent };